<template>
<article @click="$router.push({name:'ticket-message-view',params:{id:ticket.ticket_id}})" :class="{'resolved':ticket.is_resolved == 't'}">
	<header>
		<h2>
        	{{ticket.description}} 
		</h2>
		<a v-if="ticket.opened=='f'" class="badge">new</a>
		<span>
			{{ticket.updated_time | detailed_date}}
		</span>
	</header>
    
    <p>
        {{ticket.message}}
    </p>
	<hr>
</article>
</template>

<script>
import store from "@/store";
import {
    mapGetters
} from "vuex";

export default {
    name: "Ticket",

    props: {
        ticket: {}
    },
}
</script>

